module.exports = __webpack_public_path__ + "phone-notch.svg?33ad7f26e1b13375529168df8f0bdee1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone-notch.svg
// module id = 191
// module chunks = 0